// https://material.angular.io/components/table/overview
import {Component, ViewChild, EventEmitter} from '@angular/core';
import {MatPaginator,MatDialog, MatSort} from '@angular/material';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import {generalService} from '../../services/general.service';
import { DataService } from '../../utils/data.service';
import {DataSourceGrid} from '../../utils/data-source-grid.component';
import {Compania} from '../../models/compania';

/**
 * @title Table with pagination
 */
@Component({
  selector: 'my-compania-consultar',
  styleUrls: [], 
  templateUrl: 'compania-consultar.component.html',
  providers: [generalService]
})
export class CompaniaConsultarComponent {
  dataSource: DataSourceGrid | null;
  displayedColumns = ['acciones','idCompania', 'Nombre', 'Colonia'];
  public datosCompania:Array<any>;
  public compania:Compania;
  public userData: any = JSON.parse(sessionStorage.getItem('user'));
  public idCompany:number = this.userData.COMPANY_ID;

  constructor(private _generalService: generalService, public dataService: DataService, public dialog: MatDialog) {
    this.datosCompania = new Array();
    this.compania = new Compania();
  }

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  consultarCompanias(){
    this._generalService.metodoCall("compania/consultarCompanias").subscribe(
        result => {
          this.datosCompania = JSON.parse(result);
          this.dataSource = new DataSourceGrid(this.datosCompania, this.paginator, this.sort);
          if(this.datosCompania.length <= 0)
          {
            $(".mat-row").remove(".mat-row");
          }
          },
        error => {
          console.log(<any>error);
        }
      );
  }

  ngOnInit() {
    this.consultarCompanias();
  }

  eliminarConfirm(data: any)
   {
    this.compania.idCompania = data.idCompania
    let eliminarHttp = new EventEmitter<any>();
    eliminarHttp.subscribe(
      (response: any) => 
        {
         this.ngOnInit();
        }
      );
      this._generalService.modal(eliminarHttp, "confirm", "¿Desea eliminar la Compañia " + data.Nombre + "?", "compania/eliminarCompania/", this.compania);
    }

}






// WEBPACK FOOTER //
// ./src/app/compania/consultar-eliminar/compania-consultar.component.ts